import React from 'react';
import {
  Box, Grid, Stack, Typography, Divider,
} from '@mui/material';
import { Typography700 } from 'views/common/components';
import StyledGrid from 'views/information-module/ReviewsView/components/ReviewSummarySection/ReviewSummarySection.styles';
import { RatingProgress } from 'views/common/components/UI/RatingProgress/RatingProgress';
import { useTranslation } from 'next-i18next';
import { ExperienceRating } from 'views/common/components/UI/ExperienceRating/ExperienceRating';

const ReviewSummarySection = (props) => {
  const { totalRatings, experienceRating, reviewsSummarymetrics } = props;
  const { t } = useTranslation('fe_er_reviews_page');

  const formatTotalRating = () => {
    if (totalRatings >= 1000) {
      return `${parseFloat(totalRatings / 1000).toFixed(1)} K`;
    }
    return totalRatings.toString();
  };

  const formatExperienceRating = () => (experienceRating >= 1 ? parseFloat(experienceRating).toFixed(1) : 0);
  return (
    <StyledGrid container alignItems="center">
      <Grid item sm={12} md={6} lg={6}>
        <Stack direction="row" spacing={{ xs: 2, ms: 3, md: 5 }}>
          <Box>
            <Typography variant="h4">
              {t('fe_er_reviews_page:total_ratings')}
            </Typography>
            <Typography700 variant="h2" component="p">
              {formatTotalRating()}
            </Typography700>
          </Box>
          <Divider
            className="showMOBILE"
            light
            orientation="vertical"
            flexItem
          />
          <Box>
            <Typography variant="h4">
              {t('fe_er_reviews_page:average_rating')}
            </Typography>
            <Typography700 variant="h2" component="p">
              <ExperienceRating value={formatExperienceRating()} />
            </Typography700>
          </Box>
        </Stack>
        <Box className="showMOBILE" pt={1.5} pb={4}>
          <Divider light />
        </Box>
      </Grid>

      <Grid item sm={12} md={6} lg={6}>
        <Stack
          spacing={{ xs: 3, ms: 3, md: 5 }}
          direction="row"
          justifyContent={{ md: 'center', lg: 'flex-end' }}>
          {reviewsSummarymetrics.map((reviewsSummarymetric) => (
            <RatingProgress
              ratingProgressLabel={reviewsSummarymetric.label}
              value={reviewsSummarymetric.value}
            />
          ))}
        </Stack>
      </Grid>
    </StyledGrid>
  );
};

export { ReviewSummarySection };
